module.exports = __webpack_public_path__ + "img/smart-search.c01db4e1.svg";